import React, { useState, useEffect } from 'react';
import { DocumentsServices } from '../../services';
import { FileList } from '../../components';

function Indicadores() {
  const [indicators, setIndicators] = useState([]);
  useEffect(() => {
    async function fetchNews() {
      try {
        const response = await DocumentsServices.fetchDocuments('indicators');
        setIndicators(response.data);
      } catch (error) {
        console.log(error);
      }
    }

    fetchNews();
  }, []);
  return (
    <>
      <h1>Indicadores</h1>
      <p>Esta página fornece acesso aos Indicadores da <b>Cooperativa Cocrafi</b>.</p>
      <FileList  files={indicators || []} />
    </>
  )
}

export default Indicadores;